import { Box, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import SectionHeader from "../SectionHeader";
import { Link } from "react-router-dom";

export default function UsageFlow({ isFirstTimeUser = false }) {
  return (
    <Box
      className={isFirstTimeUser ? "section" : ""}
      style={isFirstTimeUser ? { paddingBottom: 0 } : {}}
    >
      <Container className="container">
        <SectionHeader
          currentPage={"解決サポート ご利用の流れ"}
          preHeading={"Flow"}
        />
        <Box style={{ marginTop: "20px", marginBottom: "50px" }}>
          <Grid container alignItems="center" className="coupon-flow-wrapper">
            <Grid item sm={7} xs={12}>
              <span className="flow-step">
                STEP <span>01</span>
              </span>
              <div className="coupon-flow-left-margin">
                <div className="coupon-flow-left">
                  <Typography component={"h4"}>
                    チケットを選んで予約する
                  </Typography>
                  <Typography>
                    <Link
                      to="/support/menu"
                      style={{
                        textDecoration: "underline",
                        color: "var(--text-color-2)",
                      }}
                    >
                      こちら
                    </Link>
                    からチケットを選んで、ご予約ください。チケットは有料となります。
                  </Typography>
                </div>
                {/* <Typography
                  style={{
                    fontSize: "0.8rem",
                    color: "#595959",
                    margin: "5px 10px",
                  }}
                >
                  ※サポートの流れが分からない、どうしていいか分からない方はまずはお電話でご相談ください。無料でご対応します。050-3818-8719
                </Typography> */}
              </div>
            </Grid>
            <Grid item xs={12} sm={5} className="coupon-flow-right">
              <Typography>
                本サービスは完全予約制となります。メニュー、担当相談員、日時を選択の上、ご予約・ご購入をお願いいたします。
              </Typography>
            </Grid>
          </Grid>
          <Grid container alignItems="center" className="coupon-flow-wrapper">
            <Grid item sm={7} xs={12}>
              <span className="flow-step">
                STEP <span>02</span>
              </span>
              <div className="coupon-flow-left-margin">
                <div className="coupon-flow-left">
                  <Typography component={"h4"}>サポート開始</Typography>
                  <Typography>
                    ご予約いただいた日時に専用の番号にお電話ください。専属相談員がお困りごとを解決いたします！
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={5} className="coupon-flow-right">
              <Typography>
                ご予約日時になりましたら、サポート電話番号までお電話ください。ご指名いただきました相談員が解決サポートいたします。
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
